import styled from "styled-components";
import { ReactComponent as Icon } from "../../assets/svg/external-link.svg";
import colours from "../../lib/colours";

export const ExternalLinkIcon = styled(Icon)`
  margin-left: 6px;
  position: relative;
  top: 2px;
  color: ${colours.th1};
`;
